class KoketaLanguageSwitcher extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';

    this.details = this.querySelector('details');
    this.trigger = this.querySelector('summary');
    this.closeButton = this.querySelector('[data-koketa-language-close]');
    this.form = this.querySelector('form');

    if (!this.details || !this.trigger) return;

    this.onToggle = () => {
      this.trigger.setAttribute('aria-expanded', String(this.details.open));

      if (this.details.open) {
        const whatsappPanel = document.querySelector('[data-whatsapp-panel]:not([hidden])');
        if (whatsappPanel) {
          whatsappPanel.hidden = true;
          document.querySelector('[data-whatsapp-trigger]')?.setAttribute('aria-expanded', 'false');
        }
      }
    };

    this.onDocumentPointerDown = (event) => {
      if (this.details.open && !this.contains(event.target)) this.close(false);
    };

    this.onKeyDown = (event) => {
      if (event.key !== 'Escape' || !this.details.open) return;
      event.preventDefault();
      this.close(true);
    };

    this.onCloseClick = () => this.close(true);

    this.onSubmit = () => {
      this.dataset.loading = 'true';
      this.setAttribute('aria-busy', 'true');
    };

    this.details.addEventListener('toggle', this.onToggle);
    this.closeButton?.addEventListener('click', this.onCloseClick);
    this.form?.addEventListener('submit', this.onSubmit);
    document.addEventListener('pointerdown', this.onDocumentPointerDown, true);
    document.addEventListener('keydown', this.onKeyDown);
    this.onToggle();
  }

  disconnectedCallback() {
    this.details?.removeEventListener('toggle', this.onToggle);
    this.closeButton?.removeEventListener('click', this.onCloseClick);
    this.form?.removeEventListener('submit', this.onSubmit);
    document.removeEventListener('pointerdown', this.onDocumentPointerDown, true);
    document.removeEventListener('keydown', this.onKeyDown);
  }

  close(returnFocus = false) {
    if (!this.details) return;
    this.details.open = false;
    if (returnFocus) this.trigger?.focus({ preventScroll: true });
  }
}

if (!customElements.get('koketa-language-switcher')) {
  customElements.define('koketa-language-switcher', KoketaLanguageSwitcher);
}
